import {live} from './constants'
import auth from 'firebase/auth';

const API = live ? 'https://etms-beab3.appspot.com/api' :'https://etms-test.appspot.com/api';
// const API = "http://localhost:8080/api";
//const API =  'https://eb7d1718.ngrok.io/api';

/** USER **/

export function createUserWithFirebase(data) {
    return post('/users', data)
}

export function createUserInDatabase(data) {
    return post('/users', data)
}

export function updateETMSUser(user) {
    return put(`/users/${auth().currentUser.uid}`, user)
}

export function getETMSUser() {
    return get(`/users/${auth().currentUser.uid}`, null, true)
}

export function addUserRole(userId, role) {
    return put(`/users/${userId}/addrole`, {'role': role})
}

export function removeUserRole(userId, role) {
    return put(`/users/${userId}/removerole`, {'role': role})
}

/** BUDGET **/

export function retrieveBudget() {
    return post(`/tests/budget`, {})
}

/** ENGINE TESTS **/

export function createTest(data) {
    return post(`/tests`, data)
}

export function updateTest(testId, data) {
    return put(`/tests/${testId}`, data)
}

export function didPrintTest(testId) {
    return post(`/tests/${testId}/didPrint`, {})
}

export function retrieveTestsInRange(start, end) {
    return post(`/tests/range`, {"start": start, "end": end})
}

export function unplannedTestsStatus() {
    return post(`/unplannedTestsStatus`, {})
}

export function sendSupportMessage(values) {
    return fetchJSONNoAuth('post', '/support', values)
}

/** doc upload**/

export function uploadDocument(files) {
    //console.log('api uploadDocument', files)
    const formData = new FormData();
    formData.isformdata = true;
    for (let i = 0; i < files.length; i++) {
        //console.log('fff', files[i].name, files[i])
        formData.append(files[i].name, files[i]);
    }
    //console.log('formdata', formData)
    return post('/documents', formData)
}


/** GROUPS **/

export function createGroup(data) {
    return post(`/groups`, data)
}

export function retrieveGroup() {
    return get(`/groups`, null, true)
}

export function retrieveGroups() {
    return get(`/groups/all`, null, true)
}

export function retrieveUsersInGroup(groupId) {
    return get(`/groups/${groupId}/users`, null, true)
}

export function addUserToGroup(groupId, userId) {
    return put(`/groups/${groupId}/users/${userId}`, {})
}

export function removeUserFromGroup(groupId, userId) {
    return del(`/groups/${groupId}/users/${userId}`, {})
}

export function deleteUser(userId) {
    return del(`/users/${userId}`)
}

export function getReport(year, quarter) {
    const url = quarter ? `/reports/${year}/${quarter}` : `/reports/${year}`
    return post(url, {})
}

export function getMDAYearly(year) {
    return post(`/tests/year/${year}`, {})
}

/** HTTP VERB WRAPPERS **/

function get(url, params, noCache) {
    const qs = [];
    if (params) {
        for (let param in params) {
            if (params.hasOwnProperty(param) && params[param]) {
                const p = encodeURIComponent(param);
                let v;
                if( Object.prototype.toString.call( params[param] ) === '[object Array]' ) {
                    v = encodeURIComponent(params[param].join(','));
                } else {
                    v = encodeURIComponent(params[param]);
                }
                qs.push(p + '=' + v);
            }
        }
    }
    if (noCache) {
        qs.push(`noCache=${new Date().getTime()}`) //IE and firefox will cache GET requests, unless we add a queryparam to force the query to be 'different'
    }

    let query = '';
    if (qs.length > 0) {
        query = '?' + qs.join('&');
    }

    return fetchJSON('get', url + query);
}

function post(url, data) {
    return fetchJSON('post', url, data);
}

function put(url, data) {
    return fetchJSON('put', url, data);
}

function del(url) {
    return fetchJSON('delete', url);
}

function fetchJSON(method, url, data) {

    let ok = false
    return auth().currentUser.getToken().then(token => {
        //return new Promise((resolve, reject) => {

        if (url.match(/^\//)) {
            url = API + url;
        }

        const headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache'
        }
        if (token) {
            headers.Authorization = `Bearer ${token}`
        }

        console.log(method.toUpperCase(), url);

        let body = null;
        if (method !== 'get' && data) {

            if (data.isformdata) {
                body = data;
                delete headers['Content-Type'] //'multipart/form-data'
            } else {
                body = JSON.stringify(data);
                console.log('post data', body)
            }

        }

        const init = {
            method: method,
            headers: headers
        }
        if (method !== 'get' && body) {
            init.body = body
        }

        const request = new Request(url, init);

        return fetch(request)
    }).then(response => {
        //console.log('raw response:',response);
        ok = response.ok
        return response.json()
    }).then(json => {
        //console.log('json response:',json);
        return ok ? Promise.resolve(json) : Promise.reject(json)
    }, e => {
        console.log('error: ', e);
        return Promise.reject(e)
    })
}

function fetchJSONNoAuth(method, url, data) {

    let ok = false
    return new Promise((resolve, reject) => {

        if (url.match(/^\//)) {
            url = API + url;
        }

        const headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache'
        };

        console.log(method.toUpperCase(), url);

        let body = null;
        if (method !== 'get' && data) {

            if (data.isformdata) {
                body = data;
                delete headers['Content-Type'] //'multipart/form-data'
            } else {
                body = JSON.stringify(data);
                console.log('post data', body)
            }

        }

        //setTimeout(() => {

        const init = {
            method: method,
            headers: headers
        }
        if (method !== 'get' && body) {
            init.body = body
        }

        const request = new Request(url, init);

        fetch(request).then(response => {
            console.log('raw response:', response);
            ok = response.ok
            return response.json()
        }).then(json => {
            //console.log('json response:',json);
            if (ok) {
                resolve(json)
            } else {
                reject(json)
            }
        }, e => {
            console.log('error: ', e);
            reject(e)
        })
    })

}






// WEBPACK FOOTER //
// ./src/api.js